import React from 'react';
import partner1 from '../../assets/Images/Dashboard/partner1.jpeg';
import partner2 from '../../assets/Images/Dashboard/partner2.jpeg';
import { ExternalLink } from 'lucide-react';
import './OurPartners.css';

/* Both logos link to the same destination in the original code. */
const RERA_URL = 'https://rerait.telangana.gov.in';

const PARTNERS = [
  { src: partner1, name: 'Telangana RERA', href: RERA_URL },
  { src: partner2, name: 'Telangana State Government', href: RERA_URL },
];

const OurPartners = () => {
  return (
    <section className="ds-marketing partners-section">
      <div className="partners-inner">
        <div className="partners-header">
          <span className="partners-tag">Working together</span>
          <h1 className="partners-title">Our partners</h1>
          <p className="ptagtext">
            Bridging the gap between the real estate industry and government to benefit
            our stakeholders, the market, and economy at large.
          </p>
        </div>

        <ul className="partners-grid">
          {PARTNERS.map(({ src, name, href }) => (
            <li key={name}>
              {/* Was a bare <img onClick>, which is not focusable, has no
                  accessible name, cannot be opened in a new tab, and gives no
                  indication it is a link. Now a real anchor. */}
              <a
                className="team-parners"
                href={href}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={src} alt="" className="team-img" aria-hidden="true" />
                <span className="team-name">
                  {name}
                  <ExternalLink size={13} aria-hidden="true" />
                </span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default OurPartners;

